import { styled } from "../../../stitches.config";
import { Box, Image } from "../../primitives";

export const CardsContainerStyled = styled(Box, {
  position: "absolute",
  top: "100%",
  left: 0,
  width: "80vw",
  height: "70vh",
  backgroundColor: "#fff",
  border: "1px solid #ccc",
  borderTop: "none",
  zIndex: 10,
  listStyle: "none",
  margin: 0,
  padding: 0,
  overflowY: "auto",
  display: "flex",
  flexWrap: "wrap",
});

export const CardWrapper = styled(Box, {
  width: 220,
  border: "1px solid #ddd",
  borderRadius: "6px",
  padding: "0.75rem",
  marginBottom: "0.5rem",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  display: "flex",
  gap: "1rem",
  position: "relative",
  height: 300,
});

export const CardImageStyled = styled(Image, {
  width: "160px",
  height: "auto",
  borderRadius: "4px",
  objectFit: "cover",
  marginTop: 5,
});
